import { Typography } from "@/components/Typography";

export const renderPhoneBox = (data, position?, userLogged?) => {
  return (
    <div
      className={`phone-box__wrapper phone-box--${data.version} ${
        userLogged ? "userLogged" : "userNotLogged"
      } ${position}`}>
      <div className="u-text-center phone-box__container">
        {data.phone?.richtext?.map((phoneBoxItem, i) => {
          return (
            <Typography
              key={i}
              Tag={phoneBoxItem.tag}
              classname={phoneBoxItem.classname}>
              {phoneBoxItem.content}
            </Typography>
          );
        })}
      </div>
    </div>
  );
};

export const formatPriceWithDecimals = (price: number, decimals: number) => {
  if (price % 1 === 0) {
    return price;
  }

  return price.toFixed(decimals);
};
